class BamaniTokenBuilder {
  constructor(root) {
    this.root = root;
    this.limit = Number(root.dataset.charmLimit || 4);
    this.state = { token: 'I Found You', finish: 'Gold', chainLength: '45 cm / 18"', charms: [], engravingEnabled: false, engraving: '', placement: 'Back of token' };
    this.mainProduct = this.readProduct('[data-main-product]');
    this.charmProduct = this.readProduct('[data-charm-product]');
    this.engravingProduct = this.readProduct('[data-engraving-product]');
    this.bind();
    this.render();
  }

  readProduct(selector) {
    const node = this.root.querySelector(selector);
    if (!node || !node.textContent.trim()) return null;
    try { return JSON.parse(node.textContent); } catch (_) { return null; }
  }

  bind() {
    this.root.querySelectorAll('[data-step-target]').forEach((button) => button.addEventListener('click', () => this.showStep(button.dataset.stepTarget)));
    this.root.querySelectorAll('[data-next-step]').forEach((button) => button.addEventListener('click', () => this.showStep(button.dataset.nextStep)));
    this.root.querySelectorAll('[data-token]').forEach((button) => button.addEventListener('click', () => {
      this.root.querySelectorAll('[data-token]').forEach(option => { option.classList.remove('is-selected'); option.setAttribute('aria-pressed', 'false'); });
      button.classList.add('is-selected');
      button.setAttribute('aria-pressed', 'true');
      this.state.token = button.dataset.token;
      if (button.dataset.image) this.root.querySelector('[data-token-preview]').src = button.dataset.image;
      this.root.querySelector('[data-token-preview]').alt = `${button.dataset.token} token`;
      this.root.querySelector('[data-preview-meaning]').textContent = button.dataset.meaning;
      this.render();
    }));
    this.root.querySelectorAll('input[type="radio"][name^="bamani-finish"]').forEach((input) => input.addEventListener('change', () => { this.state.finish = input.value; this.render(); }));
    this.root.querySelectorAll('[data-chain-length]').forEach((input) => input.addEventListener('change', () => { this.state.chainLength = input.value; this.render(); }));
    this.root.querySelectorAll('[data-category]').forEach((button) => button.addEventListener('click', () => this.filterCharms(button)));
    this.root.querySelectorAll('[data-charm]').forEach((button) => button.addEventListener('click', () => this.toggleCharm(button)));
    this.root.querySelector('[data-initial-letter]').addEventListener('change', (event) => {
      const charm = this.state.charms.find(item => item.name === 'Initial');
      if (charm) charm.initial = event.target.value;
      this.render();
    });
    const toggle = this.root.querySelector('[data-engraving-toggle]');
    const fields = this.root.querySelector('[data-engraving-fields]');
    toggle.addEventListener('change', () => { this.state.engravingEnabled = toggle.checked; fields.hidden = !toggle.checked; this.render(); });
    const engraving = this.root.querySelector('[data-engraving-text]');
    engraving.addEventListener('input', () => { this.state.engraving = engraving.value.trim(); this.root.querySelector('[data-engraving-count]').textContent = engraving.value.length; this.render(); });
    this.root.querySelector('[data-engraving-placement]').addEventListener('change', (event) => { this.state.placement = event.target.value; this.render(); });
    this.root.querySelectorAll('[data-tag-engraving]').forEach(panel => {
      const toggle = panel.querySelector('[data-tag-toggle]');
      const input = panel.querySelector('[data-tag-text]');
      toggle.addEventListener('change', () => {
        const charm = this.state.charms.find(item => item.name === panel.dataset.tagEngraving);
        if (charm) charm.engravingEnabled = toggle.checked;
        this.render();
      });
      input.addEventListener('input', () => {
        const charm = this.state.charms.find(item => item.name === panel.dataset.tagEngraving);
        if (charm) charm.engraving = input.value.slice(0, 10);
        this.render();
      });
    });
    this.root.querySelector('[data-add-configuration]').addEventListener('click', () => this.addToCart());
  }

  showStep(name) {
    this.root.querySelectorAll('[data-step-target]').forEach((button) => { const active = button.dataset.stepTarget === name; button.classList.toggle('is-active', active); if (active) button.setAttribute('aria-current', 'step'); else button.removeAttribute('aria-current'); });
    this.root.querySelectorAll('[data-step-panel]').forEach((panel) => { const active = panel.dataset.stepPanel === name; panel.classList.toggle('is-active', active); panel.hidden = !active; });
    if (window.innerWidth < 750) this.root.querySelector('.bamani-builder__controls').scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  filterCharms(button) {
    this.root.querySelectorAll('[data-category]').forEach(tab => tab.classList.toggle('is-active', tab === button));
    this.root.querySelectorAll('[data-charm]').forEach((item) => { item.hidden = button.dataset.category !== 'all' && item.dataset.categoryName !== button.dataset.category; });
  }

  toggleCharm(button) {
    const name = button.dataset.charm;
    const index = this.state.charms.findIndex(charm => charm.name === name);
    if (index >= 0) {
      this.state.charms.splice(index, 1);
      button.classList.remove('is-selected');
      button.setAttribute('aria-pressed', 'false');
    } else if (this.state.charms.length < this.limit) {
      const charm = { name, meaning: button.dataset.meaning, image: button.dataset.image, priceSilver: button.dataset.priceSilver, priceGold: button.dataset.priceGold };
      if (name === 'Initial') charm.initial = this.root.querySelector('[data-initial-letter]').value;
      this.state.charms.push(charm);
      button.classList.add('is-selected');
      button.setAttribute('aria-pressed', 'true');
    } else {
      const status = this.root.querySelector('[data-builder-status]');
      status.textContent = `Choose up to ${this.limit} charms.`;
      this.showStep('charms');
    }
    this.render();
  }

  render() {
    const chainOnly = this.state.token === 'Chain only';
    if (chainOnly) {
      this.state.engravingEnabled = false;
      this.root.querySelector('[data-engraving-toggle]').checked = false;
      this.root.querySelector('[data-engraving-fields]').hidden = true;
    }
    this.root.querySelector('[data-main-engraving]').hidden = chainOnly;
    this.root.querySelectorAll('[data-tag-engraving]').forEach(panel => {
      const charm = this.state.charms.find(item => item.name === panel.dataset.tagEngraving);
      panel.hidden = !charm;
      panel.querySelector('[data-tag-toggle]').checked = !!charm?.engravingEnabled;
      panel.querySelector('[data-tag-fields]').hidden = !charm?.engravingEnabled;
      panel.querySelector('[data-tag-text]').value = charm?.engraving || '';
      panel.querySelector('[data-tag-count]').textContent = (charm?.engraving || '').length;
    });
    this.root.querySelector('[data-token-preview]').hidden = chainOnly;
    this.root.querySelector('.bamani-builder__preview-stage').hidden = chainOnly && !this.state.charms.length;
    this.root.querySelector('[data-preview-label]').textContent = chainOnly ? 'YOUR CHAIN' : 'YOUR TOKEN';
    this.root.querySelectorAll('[data-base-label]').forEach(node => { node.textContent = chainOnly ? 'Chain' : 'Main token + chain'; });
    this.root.querySelectorAll('[data-subtotal-label]').forEach(node => { node.textContent = chainOnly ? 'Chain + charms' : 'Main token + chain + charms'; });
    this.root.querySelectorAll('[data-finish-price]').forEach(node => { node.textContent = this.formatPrice(chainOnly ? this.chainPrice(node.dataset.finishPrice) : node.dataset.finishPrice === 'Silver' ? 110000 : 120000); });
    this.root.querySelector('[data-chain-only-price]').textContent = this.formatPrice(this.chainPrice());
    this.root.querySelector('[data-preview-title]').textContent = this.state.token;
    this.root.querySelector('[data-summary-token]').textContent = chainOnly ? 'None' : this.state.token;
    this.root.querySelector('[data-summary-finish]').textContent = this.state.finish === 'Gold' ? 'Gold plated' : 'Silver';
    const chainSummary = this.root.querySelector('[data-summary-chain-length]');
    if (chainSummary) chainSummary.textContent = this.state.chainLength;
    this.root.querySelectorAll('[data-base-price]').forEach((node) => { node.textContent = `${new Intl.NumberFormat('sv-SE').format(this.basePrice() / 100)} kr`; });
    this.root.querySelectorAll('[data-charm-price]').forEach(node => { node.textContent = this.formatPrice(this.charmPrice()); });
    this.root.querySelectorAll('[data-gemstone-price]').forEach(node => { node.textContent = this.formatPrice(this.charmPrice(node.closest('[data-charm]').dataset)); });
    this.root.querySelectorAll('[data-charms-subtotal]').forEach(node => { node.textContent = this.formatPrice(this.charmsSubtotal()); });
    this.root.querySelectorAll('[data-configuration-subtotal]').forEach(node => { node.textContent = this.formatPrice(this.basePrice() + this.charmsSubtotal()); });
    this.root.querySelectorAll('[data-engraving-price]').forEach(node => { node.textContent = this.formatPrice(this.engravingPrice()); });
    this.root.querySelectorAll('[data-configuration-total]').forEach(node => { node.textContent = this.formatPrice(this.basePrice() + this.charmsSubtotal() + this.engravingPrice()); });
    this.root.querySelectorAll('[data-engraving-placement] option').forEach(option => {
      option.disabled = chainOnly && option.value === 'Back of token';
      const label = 'Back of main token';
      option.textContent = `${label} - ${this.formatPrice(this.engravingUnitPrice(option.value))}`;
    });
    const initial = this.state.charms.find(charm => charm.name === 'Initial');
    this.root.querySelector('[data-initial-fields]').hidden = !initial;
    this.root.querySelector('[data-summary-charms]').textContent = this.state.charms.length ? this.state.charms.map(charm => charm.name === 'Initial' ? `Initial ${charm.initial}` : charm.name).join(', ') : 'None selected';
    this.root.querySelector('[data-summary-engraving]').textContent = this.engravings().map(item => `${item.text.trim() || 'Text required'} · ${item.placement}`).join('; ') || 'None';
    this.root.querySelector('[data-charm-counter]').textContent = `${this.state.charms.length} / ${this.limit} selected`;
    this.root.querySelector('[data-preview-charms]').innerHTML = this.state.charms.map(charm => `<img src="${charm.image}" alt="">`).join('');
  }

  matchingVariant(product, values) {
    if (!product || !Array.isArray(product.variants)) return null;
    const needles = values.map(value => value.toLowerCase());
    return product.variants.find((variant) => {
      const haystack = [variant.title, variant.option1, variant.option2, variant.option3].filter(Boolean).join(' ').toLowerCase();
      return needles.every(needle => haystack.includes(needle));
    });
  }

  basePrice() {
    if (this.state.token === 'Chain only') return this.chainPrice();
    return this.state.finish === 'Silver' ? 110000 : 120000;
  }

  chainPrice(finish = this.state.finish) {
    return finish === 'Silver' ? 50000 : 60000;
  }

  charmPrice(charm) {
    const specialPrice = this.state.finish === 'Silver' ? charm?.priceSilver : charm?.priceGold;
    if (specialPrice != null && Number.isFinite(Number(specialPrice)) && Number(specialPrice) > 0) return Number(specialPrice);
    return this.state.finish === 'Silver' ? 90000 : 100000;
  }

  charmsSubtotal() {
    return this.state.charms.reduce((sum, charm) => sum + this.charmPrice(charm), 0);
  }

  formatPrice(cents) {
    return `${new Intl.NumberFormat('sv-SE').format(cents / 100)} kr`;
  }

  engravingUnitPrice() {
    return 40000;
  }

  engravings() {
    const items = this.state.engravingEnabled && this.state.token !== 'Chain only' ? [{ placement: 'Back of token', text: this.state.engraving || '' }] : [];
    this.state.charms.filter(charm => ['Heart Date Tag', 'Round Date Tag', 'Bar Date Tag'].includes(charm.name) && charm.engravingEnabled).forEach(charm => items.push({ placement: charm.name, text: charm.engraving || '' }));
    return items;
  }

  engravingPrice() {
    return this.engravings().length * this.engravingUnitPrice();
  }

  async addToCart() {
    const status = this.root.querySelector('[data-builder-status]');
    if (this.state.charms.some(charm => charm.name === 'Initial' && !/^[A-Z]$/.test(charm.initial || ''))) {
      status.textContent = 'Please choose your initial.';
      this.showStep('charms');
      return;
    }
    const engravings = this.engravings();
    if (engravings.some(item => !item.text.trim() || item.text.length > 10)) {
      status.textContent = 'Please enter 1 to 10 characters for each engraving.';
      return;
    }
    const engravingItems = engravings.map(item => ({ ...item, variant: this.matchingVariant(this.engravingProduct, [item.placement, this.state.finish]) }));
    if (engravingItems.some(item => !item.variant || Number(item.variant.price) !== this.engravingUnitPrice())) {
      status.textContent = 'This personalisation is not available yet.';
      return;
    }
    const mainVariant = this.matchingVariant(this.mainProduct, [this.state.token, this.state.finish]);
    const charmItems = this.state.charms.map(charm => ({ charm, variant: this.matchingVariant(this.charmProduct, [charm.name, this.state.finish]) }));
    if (!mainVariant || charmItems.some(item => !item.variant)) {
      status.textContent = 'This combination is not available yet.';
      return;
    }
    // Shopify owns checkout prices; block variants that disagree with displayed prices.
    if (Number(mainVariant.price) !== this.basePrice() || charmItems.some(item => Number(item.variant.price) !== this.charmPrice(item.charm))) {
      status.textContent = 'This combination is not available yet.';
      return;
    }
    const properties = { 'Bamani Token': this.state.token, Finish: this.state.finish, 'Chain length': this.state.chainLength };
    if (this.state.engravingEnabled) { properties.Engraving = this.state.engraving; properties.Placement = this.state.placement; }
    const items = [{ id: mainVariant.id, quantity: 1, properties }, ...charmItems.map(item => ({ id: item.variant.id, quantity: 1, properties: { 'Part of token': this.state.token, ...(item.charm.name === 'Initial' ? { Initial: item.charm.initial } : {}) } }))];
    engravingItems.forEach(item => items.push({ id: item.variant.id, quantity: 1, properties: { Engraving: item.text.trim(), Placement: item.placement, Finish: this.state.finish } }));
    try {
      status.textContent = 'Adding your story…';
      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items }) });
      if (!response.ok) throw new Error('Cart request failed');
      window.location.href = window.routes?.cart_url || '/cart';
    } catch (_) { status.textContent = 'We could not add this configuration. Please try again.'; }
  }
}

document.addEventListener('DOMContentLoaded', () => document.querySelectorAll('[data-bamani-builder]').forEach(root => new BamaniTokenBuilder(root)));
